"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchBlock = void 0;

var _react = _interopRequireDefault(require("react"));

var _theming = require("@storybook/theming");

var _designSystem = require("@storybook/design-system");

var _Search = require("./Search");

var _styles = require("./shared/styles");

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var Image = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "e1azs4017"
} : {
  target: "e1azs4017",
  label: "Image"
})(process.env.NODE_ENV === "production" ? {
  name: "o11quc",
  styles: "margin-right:20px;flex:none;svg,img{display:block;width:40px;height:auto;}"
} : {
  name: "o11quc",
  styles: "margin-right:20px;flex:none;svg,img{display:block;width:40px;height:auto;}",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
var Title = (0, _theming.styled)("h2", process.env.NODE_ENV === "production" ? {
  target: "e1azs4016"
} : {
  target: "e1azs4016",
  label: "Title"
})(_styles.text.largeBold, ";color:", _styles.color.darkest, ";margin-bottom:0.25rem;");
var Desc = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "e1azs4015"
} : {
  target: "e1azs4015",
  label: "Desc"
})(_styles.text.large, ";color:#586368;");
var Meta = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "e1azs4014"
} : {
  target: "e1azs4014",
  label: "Meta"
})("width:100%;display:flex;flex-direction:column;@media (min-width: ", _styles.breakpoints[2], "px){flex-direction:row;justify-content:space-between;}");
var Wrapper = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "e1azs4013"
} : {
  target: "e1azs4013",
  label: "Wrapper"
})("padding:30px;border-radius:", _styles.spacing.borderRadius.small, "px;border:1px solid ", _styles.color.border, ";display:flex;@media (min-width: ", _styles.breakpoints[2], "px){grid-column:1/span 2;}");
var SupportFeatureGrid = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "e1azs4012"
} : {
  target: "e1azs4012",
  label: "SupportFeatureGrid"
})("display:grid;gap:30px;grid-template-columns:1fr;margin:0 auto;@media (min-width: ", _styles.breakpoints[2], "px){grid-template-columns:1fr 1fr;}");
var SearchWrapper = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "e1azs4011"
} : {
  target: "e1azs4011",
  label: "SearchWrapper"
})("flex:1 1 auto;margin-top:1rem;@media (min-width: ", _styles.breakpoints[2], "px){margin-top:0;margin-left:30px;max-width:280px;}");
var StyledSearch = ( /*#__PURE__*/0, _theming.styled)(_Search.Search, process.env.NODE_ENV === "production" ? {
  target: "e1azs4010"
} : {
  target: "e1azs4010",
  label: "StyledSearch"
})("button{font-size:", _styles.typography.size.s2, "px;border-radius:", _styles.spacing.borderRadius.small, "px;height:40px!important;&:hover,&:active,&:focus{height:40px;}}");

var SearchBlock = function SearchBlock(_ref) {
  var version = _ref.version,
      apiKey = _ref.apiKey;
  return /*#__PURE__*/_react["default"].createElement(Wrapper, null, /*#__PURE__*/_react["default"].createElement(Image, null, /*#__PURE__*/_react["default"].createElement(_designSystem.ColoredIcons.Search, {
    "aria-label": "search"
  })), /*#__PURE__*/_react["default"].createElement(Meta, null, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(Title, null, "Search the docs"), /*#__PURE__*/_react["default"].createElement(Desc, null, "There\u2019s probably an article for your issue already.")), /*#__PURE__*/_react["default"].createElement(SearchWrapper, null, /*#__PURE__*/_react["default"].createElement(StyledSearch, {
    version: version,
    apiKey: apiKey
  }))));
};

exports.SearchBlock = SearchBlock;